// extracted by mini-css-extract-plugin
export var label = "_fq-2";
export var slideContainer = "_fq-0";
export var slider = "_fq-1";